import { useState, useEffect } from 'react'
import { useMsal, useIsAuthenticated } from '@azure/msal-react'

// Fetches the signed-in user's profile photo from Microsoft Graph.
// Returns a blob URL for the image, or null if unavailable.
export function useProfilePhoto(): string | null {
  const { instance, accounts } = useMsal()
  const isAuthenticated = useIsAuthenticated()
  const [photoUrl, setPhotoUrl] = useState<string | null>(null)

  useEffect(() => {
    if (!isAuthenticated || accounts.length === 0) return

    let revoked = false

    async function fetchPhoto() {
      try {
        const response = await instance.acquireTokenSilent({
          scopes: ['User.Read'],
          account: accounts[0],
        })

        const res = await fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
          headers: { Authorization: `Bearer ${response.accessToken}` },
        })

        if (!res.ok) return

        const blob = await res.blob()
        if (!revoked) {
          setPhotoUrl(URL.createObjectURL(blob))
        }
      } catch {
        // Token acquisition or fetch failed — fall back to initials
      }
    }

    fetchPhoto()

    return () => {
      revoked = true
      setPhotoUrl((prev) => {
        if (prev) URL.revokeObjectURL(prev)
        return null
      })
    }
  }, [instance, accounts, isAuthenticated])

  return photoUrl
}
